import { render } from "./J2003.vue?vue&type=template&id=711a5b52"
import script from "./J2003.vue?vue&type=script&lang=js"
export * from "./J2003.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__